//react...
import React from "react";

import "./Examinations.styles.css";

const MohammadjavadFallahiDarooni = () => {
  return (
    <div className="examination-container">
      <div className="box">
        <div className="name"> Mr. Mohammadjavad Fallahi Darooni </div>

        <div className="score"> score: 100 / 100</div>
      </div>
    </div>
  );
};

export default MohammadjavadFallahiDarooni;
